export const OWNER_SCOPE_VALUES = { ALL: "all", MINE: "mine", CSM: "csm" };
export const OWNER_SCOPE_STORAGE_KEY = "owner_scope";

const CSM_PREFIX = "csm:";
const UUID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;

export const buildCsmScope = (csOwnerId) => `${CSM_PREFIX}${csOwnerId}`;

// True when `scope` names the current user's own book as a CSM scope. An admin's own entry
// is not offered in the "view as" list, because "My Customers" is the same book (PAN-592);
// the one rule for "is this my entry", so the list, the resolver and the label cannot drift.
// False while the current user is unknown.
export const isOwnCsmScope = (scope, currentUserId) =>
  Boolean(currentUserId) && scope === buildCsmScope(currentUserId);

export const parseOwnerScope = (token) => {
  if (typeof token === "string" && token.startsWith(CSM_PREFIX)) {
    const csOwnerId = token.slice(CSM_PREFIX.length);
    if (UUID_PATTERN.test(csOwnerId)) {
      return { mode: "csm", csOwnerId };
    }
  }
  if (token === OWNER_SCOPE_VALUES.MINE) {
    return { mode: "mine", csOwnerId: null };
  }
  return { mode: "all", csOwnerId: null };
};

export const isValidOwnerScope = (token) => {
  if (token === OWNER_SCOPE_VALUES.ALL || token === OWNER_SCOPE_VALUES.MINE) {
    return true;
  }
  if (typeof token === "string" && token.startsWith(CSM_PREFIX)) {
    return UUID_PATTERN.test(token.slice(CSM_PREFIX.length));
  }
  return false;
};

export const ownerScopeQueryString = (token) => {
  const parsed = parseOwnerScope(token);
  if (parsed.mode === "mine") {
    return "owner_scope=mine";
  }
  if (parsed.mode === "csm") {
    return `cs_owner_id=${parsed.csOwnerId}`;
  }
  return "";
};
